import * as actionTypes from '../../types/root';

export const clearRootStateAction = () => (dispatch) => {
  dispatch({ type: actionTypes.CLEAR_ROOT_STATE });
};
